<template>
  <div class="quote-tab page-container">
    <h1>Quotes</h1>
    <div class="top-right">
      <v-button
        size="small"
        type="primary"
        @click="handlerQuote"
      >New Quote</v-button>
    </div>
    <quote-list
      :isAccount="true"
      :is-fina="isFina"
      :customer-id="customerId"></quote-list>
  </div>
</template>

<script>
import MixinOptions from '@/mixins/options'
import {getAccountQuoteList} from '@/api/account'
import quoteList from '@/views/records/quote/quoteList'
import {mapActions} from 'vuex'
export default {
  name: 'QuoteTab',
  components:{
    quoteList
  },
  mixins: [MixinOptions],
  props: {
    // customerId: [String, Number]
  },
  inject:['customer_id','merchant_platform','detailData'],
  data() {
    return {
      pageConfig: {
        //  分頁配置
        currentPage: 1,
        total: 10
      },
      statusOptions: [
        {
          name: 'Selected Quick Quote',
          id: 'Selected Quick Quote'
        },
        {
          name: 'Final Quote',
          id: 'Final Quote'
        }
      ],
      date: '',
      product_id: [],
      company_id: [],
      stts: [],
      search: '',
      tableData: []
    }
  },
  computed:{
    customerId(){
      return this.customer_id()
    },
    isFina(){
      let merchant_platform = this.merchant_platform()
      return merchant_platform ==2
    },
    customer_profile(){
      const {customer_profile = {}} = this.detailData()
      return customer_profile
    },
  },
  created() {
    this.network().getAccountQuoteList()
  },
  methods: {
    ...mapActions('account', ['setCustomerId','setSelectCustomerData','setReferCustomerId','setSelectReferCustomerData']),
    routerToQuote({ id, product_id }) {
      this.$router.push({
        path: '/records/quote/detail',
        query: {
          order_id: id,
          product_id
        }
      })
    },
    handlerQuote(){
      this.setCustomerId(this.customerId)
      this.setSelectCustomerData(this.customer_profile)
      this.setReferCustomerId(this.customerId)
      this.setSelectReferCustomerData(this.customer_profile)
      this.$router.push({
        path:'/quoting/select/create',
        query:{
          hasCustomer:true
        }
      })
    },
    handlerSelectAll(target) {
      let origin = ''
      switch(target) {
        case 'product_id':
          origin = 'productTypeOptions'
          break
        case 'stts':
          origin = 'statusOptions'
          break
        case 'company_id':
          origin = 'insurerOptions'
          break
      }
      const data = this[origin].reduce((result, item) => {
        result.push(item.id)
        return result
      }, [])
      this[target] = data
      this.filterData()
    },
    // todo 篩選還沒做
    filterData() {
      this.pageConfig.currentPage = 1
      this.network().getAccountQuoteList()
    },
    currentChange(page) {
      this.pageConfig.currentPage = page
      this.network().getAccountQuoteList()
    },
    network() {
      return {
        getAccountQuoteList: async () => {
          const { data } = await getAccountQuoteList({
            quote_dt_start: this.date[0],
            quote_dt_end: this.date[1],
            product_id: this.product_id,
            company_id: this.company_id,
            stts: this.stts,
            search: this.search,
            page: this.pageConfig.currentPage,
            customer_id: this.customerId
          })
          this.tableData = data.data
          this.pageConfig.total = data.total
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.quote-tab {
    position: relative;
    h1 {
        padding-bottom: 15px;
        color: #616266;
        font-size: 20px;
    }
    .top-right {
        position: absolute;
        top: 0;
        right: 0;
    }
    .filter-container {
        .filter-box {
            margin-bottom: 10px;
            .label {
                display: block;
                padding-bottom: 5px;
                font-size: 14px;
                font-weight: bold;
                .all {
                    display: inline-block;
                    padding-left: 15px;
                    color: #409EFF;
                    font-weight: 500;
                    cursor: pointer;
                }
            }
            .search-box {
                width: 400px;
            }
            .quote-box {
                width: 300px;
            }
        }
    }
  ::v-deep .el-table{
    border-radius: 4px;
  }
  ::v-deep .tableHeader {
    margin-top: 30px;
    background: #E1E4E8 !important;

    th {
      background-color: #F6F8FA !important;
      font-family: Inter;
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      letter-spacing: -0.15px;
      /* Text/text-gray-dark */
      color: #24292E!important;
    }
  }
}
</style>
